import {Component, Inject} from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
   selector: 'app-confirm-delete',
   templateUrl: 'confirm-delete.component.html',
   styleUrls: ['confirm-delete.component.css']
})
export class ConfirmDeleteComponent {
   progress: boolean;
   isMultiSelect = false;
   itemSelList: any[] = [];
   selectListId: any[] = [];

   constructor(private dialogRef: MatDialogRef<ConfirmDeleteComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {
      if (this.data.isMultiSelect) {
         this.isMultiSelect = this.data.isMultiSelect;
         this.itemSelList = this.data.listItem;
         this.selectListId = this.itemSelList;
      }
   }

   /**
    *
    * @detail : deleteFile
    */
   justDelete(deleteButton: MatButton, cancelButton: MatButton) {
      deleteButton.disabled = true;
      cancelButton.disabled = true;
      this.progress = true;
      if (!this.data.access_token_google_drive) {
         if (this.isMultiSelect) {
            this.data.service.multipleDeleteFile(this.selectListId)
               .subscribe(
                  () => {
                     this.dialogRef.close(true);
                     this.data.data.docList.showdocument.emit();
                     this.data.translate.get('alert.confirm_delete').subscribe(s => {
                        this.data.toast.success(s);
                     });
                  },
                  error => {
                     this.dialogRef.close();
                     this.data.toast.error(error);
                  });
         } else {
            if (this.data.service) {
               this.data.service.deleteFile(this.data.item.id)
                  .subscribe(
                     () => {
                        this.dialogRef.close(true);
                        this.onAlert('alert.confirm_delete');
                     },
                     error => {
                        this.dialogRef.close();
                        this.data.toast.error(error);
                     });
            } else {
               this.dialogRef.close(true);
               this.onAlert('alert.confirm_delete');
            }
         }
      } else {
         this.data.service.deleteGoogleDriveFile(this.data.item.id , this.data.access_token_google_drive)
         .subscribe(() => {
            this.dialogRef.close(true);
            this.onAlert('alert.confirm_delete');
         },
         error => {
            this.dialogRef.close();
            this.data.toast.error(error);
         });
      }
   }

   onAlert(text: string) {
      this.data.translate.get(text).subscribe(s => {
         this.data.toast.success(s);
      });
   }
}
